<template>
  <v-row no-gutters class="d-flex justify-space-between px-2" align="center">
    <v-col
      :cols="mobile ? '4' : '6'"
      v-for="(icon, idx) in icons"
      :key="idx"
      :class="(icon.class || []).join(' ')"
      :align-self="mobile ? 'center' : 'end'"
    >
      <img
        :style="`height: ${icon.height}; max-height: ${icon.height}`"
        :class="icon.imgClass ? icon.imgClass.join(' ') : ''"
        :src="require(`@/assets/images/${icon.value}.svg`)"
      />
    </v-col>
    <v-col v-if="mobile" cols="auto" class="pb-2"> <language-picker /> </v-col>
  </v-row>
</template>

<script>
import LanguagePicker from '@/components/shared/LanguagePicker';
export default {
  name: 'TheSidebarHeader',
  components: { LanguagePicker },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    currentLng() {
      return this.$i18n.locale;
    },
    icons() {
      return [
        { value: `logo-lodz-${this.currentLng}`, height: this.mobile ? '40px' : '49px', class: ['text-left'] },
        {
          value: `logo-psi-${this.currentLng}`,
          height: this.mobile ? '40px' : '52px',
          class: ['text-right'],
          imgClass: [...(this.mobile ? [] : ['pt-1'])],
        },
      ];
    },
  },
};
</script>
